import React, {Component} from 'react'
import Header from './Header'

const Cover = () => (
  <div 
    className="covervid-wrapper z1" 
    style={{
      backgroundImage: `url(../images/cover.jpg)`
    }} 
  />
)

class Container extends Component {
  componentDidMount () {
    const ScrollReveal = require('scrollreveal')
    const fooReveal = {
      distance: '-90px',
      easing: 'cubic-bezier(0.39, 0.58, 0.57, 1)',
      scale: 1
    }
    const sr = ScrollReveal()
    sr.reveal(this.refs.content, fooReveal)
  }
  render () {
    return (
      <div className='container relative flex flex-auto'>
        <div className='inner flex-auto z2' ref='content'>
          <Header/>
          {this.props.children}
        </div>
        <Cover/>
      </div>
    )
  }
}

export default Container



// WEBPACK FOOTER //
// ./components/Container.js